import { defineStyle, defineStyleConfig } from '@/ui';

const text = defineStyle({
  textTransform: 'uppercase',
});

const xs = defineStyle({
  fontSize: '0.75em',
});

// Pink-brand pill marking a printable/PDF layout (e.g. layout cards, view picker).
const printable = defineStyle({
  bg: 'brand.40',
  color: 'brand.600',
  borderRadius: 'ah-pill',
  textTransform: 'uppercase',
  fontWeight: 700,
  fontSize: '9px',
  letterSpacing: '0.04em',
  px: 1.5,
  py: '2px',
});

// Neutral pill marking the view a fresh visitor lands on (view pickers). The
// selected row in both pickers is solid black, so callers override bg/color
// there rather than the variant guessing at its background.
const defaultView = defineStyle({
  bg: 'line.soft',
  color: 'ink.muted',
  borderRadius: 'ah-pill',
  textTransform: 'uppercase',
  fontWeight: 700,
  fontSize: '9px',
  letterSpacing: '0.04em',
  px: 1.5,
  py: '2px',
});

export const Badge = defineStyleConfig({
  sizes: { xs },
  variants: { text, printable, defaultView },
});
